const startTime = window.performance.now()

export function getTime() {
    const ms = window.performance.now() - startTime

    return {
        "ms": ms,
        "s": ms / 1000
    }
}
